// ─────────────────────────────────────────────
//  RoomPeople — the read-only "who is in this room" strip at the top of the
//  case modal: surgeon, supervising doctor, and the one or two CRNAs.
//
//  ⚠️ IT EXISTS BECAUSE A SECOND CRNA PUSHES THE DOCTOR DOWN. The supervising
//  doctor's section is the LAST thing in this dialog, and adding a second CRNA
//  section above it pushes it further below the fold on a laptop. Surgeon and
//  supervising doctor are the two facts an anesthesiologist checks first when
//  they open a room, so they are stated once at the top where the case times
//  are, and stay editable in their own sections below.
//
//  Deliberately not editable: a second place to change the surgeon is a second
//  place for the surgeon to be changed from, and this dialog already has one.
// ─────────────────────────────────────────────
import React from "react";
import st from "./caseModalStyles";

function Cell({ kind, name }) {
  return (
    <div style={st.personCell}>
      <span style={st.personKind}>{kind}</span>
      <span style={name ? st.personName : st.personNone}>{name || "— none —"}</span>
    </div>
  );
}

export default function RoomPeople({ surgeon, attendingName, seatName, secondName }) {
  return (
    <div style={st.section}>
      <div style={st.sectionTitle}>In this room</div>
      <div style={st.people}>
        <Cell kind="Surgeon" name={surgeon} />
        <Cell kind="Supervising MD / DO" name={attendingName} />
        {/* "CRNA / AA" alone when one person holds the room — the same words the
            board uses. Numbered only once there are two to tell apart. */}
        <Cell kind={secondName ? "CRNA / AA (holds the room)" : "CRNA / AA"} name={seatName} />
        {secondName && <Cell kind="Second CRNA / AA" name={secondName} />}
      </div>
    </div>
  );
}
